import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/login.css';
import eyeIcon from '../assets/images/eye.svg';
import CKALogo from '../assets/images/CKA Birla_Logo.svg';
import { login } from '../features/authSlice';
import BirlanuLogo from '../assets/images/birlanu_water_tank_logo.svg';
import eyeShowIcon from '../assets/images/eye_show.svg';

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  React.useEffect(() => {
    const token = localStorage.getItem('jwt');
    if (token && token !== 'undefined' && token !== '') {
      navigate('/dashboard');
    }
  }, [navigate]);

  const schema = yup.object().shape({
    email: yup
      .string()
      .email('Enter a valid email address')
      .required('Email is required'),
    password: yup
      .string()
      .min(6, 'Password must be at least 6 characters')
      .required('Password is required'),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await schema.validate({ email, password }, { abortEarly: false });
      setErrors({});
      // Use Redux login action
      const resultAction = await dispatch(login({ email, password }));
      if (login.fulfilled.match(resultAction)) {
        if (resultAction.payload && resultAction.payload.token) {
          localStorage.setItem('jwt', resultAction.payload.token);
        }
        if (
          resultAction.payload &&
          resultAction.payload.user &&
          resultAction.payload.user.id
        ) {
          localStorage.setItem('userId', resultAction.payload.user.id);
        }
        if (
          resultAction.payload &&
          resultAction.payload.user &&
          resultAction.payload.user.role
        ) {
          localStorage.setItem('role', resultAction.payload.user.role);
        }
        navigate('/dashboard');
      } else {
        toast.error(
          resultAction.payload || 'Login failed. Please check your credentials.'
        );
      }
    } catch (validationError) {
      const newErrors = {};
      if (validationError.inner) {
        validationError.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
      }
      setErrors(newErrors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div>
        <div className="login-logo">
          <img src={BirlanuLogo} alt="Birlanu Water Tank Logo" />
        </div>
        <div className="login-form">
          <h1>Welcome!</h1>
          <h3>Enter your email and password</h3>
          <form onSubmit={handleSubmit} className="form-info">
            <label htmlFor="email" className="form-label">
              E-mail
            </label>
            <input
              type="email"
              id="email"
              className="form-input"
              style={{
                marginBottom: errors.email ? '4px' : '',
                borderColor: errors.email ? '#D7184D' : '',
              }}
              placeholder="Enter your email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (errors.email) setErrors(prev => ({ ...prev, email: undefined }));
              }}
            />
            {errors.email && (
              <span className="login-input-error">{errors.email}</span>
            )}
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <div className="password-section">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                className="form-input"
                style={{
                  marginBottom: errors.password ? '4px' : '',
                  borderColor: errors.password ? '#D7184D' : '',
                }}
                placeholder="Enter your password"
                value={password}
                onChange={e => {
                  // Remove spaces from input
                  const value = e.target.value.replace(/\s/g, '');
                  setPassword(value);
                  if (errors.password) setErrors(prev => ({ ...prev, password: undefined }));
                }}
                onKeyDown={e => {
                  if (e.key === ' ') e.preventDefault();
                }}
              />
              <span
                className="ico-eye"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Toggle password visibility"
                role="button"
                tabIndex={0}
              >
                <img
                  src={showPassword ? eyeShowIcon : eyeIcon}
                  alt={showPassword ? 'Hide password' : 'Show password'}
                  style={{
                    width: 24,
                    height: 24,
                  }}
                />
              </span>
            </div>
            {errors.password && (
              <span className="login-input-error">{errors.password}</span>
            )}
            <div className="forgot-link-section">
              <Link to="/forgot-password" className="forgot-link">
                Forgot Password?
              </Link>
            </div>
            <button
              type="submit"
              className="login-btn"
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>

          </form>
          <div className="login-divider">
            <span>Or</span>
          </div>
          <div className="login-register">
            <span>Don’t have an account? </span>
            <Link to="/register" className="login-register-link">
              Sign Up
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-section">
        <img src={CKALogo} alt="CKA Birla Logo" />
        <div className="footer-links">
          <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link>
          <span>&nbsp;|&nbsp;</span>
          <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
